import {ReactNode} from 'react';

import OnboardingSectionTitle from './OnboardingSectionTitle';
import {EmpionPaper} from '../../../../components/EmpionPaper/EmpionPaper';

interface OnboardingSectionProps {
  title: string;
  children: ReactNode;
}

export default function OnboardingSection({title, children}: OnboardingSectionProps) {
  return (
    <EmpionPaper
      sx={{
        mt: 5,
        borderRadius: 3,
        p: 3,
      }}
    >
      <OnboardingSectionTitle title={title} />
      {children}
    </EmpionPaper>
  );
}
